import { useTranslation } from "react-i18next";
import { Header } from "semantic-ui-react";

export default function PageNotFound() {
	const { t } = useTranslation();

	return <Header as="h1">{t("pageNotFound", "404 - page not found")}</Header>;
}
